import React, { useRef }  from 'react';


import './main.css';

import Landing from './landing/landing'
import Header from './header/header'

import Services from './services/services'

import Portfolio from './portfolio/portfolio'

import Testimonials from './testimonials/testimonials'

import Contact from './contact/contact'

function Main() {
    const landingRef = useRef()
    const servicesRef = useRef()
    const portfolioRef = useRef()
    const testimonialsRef = useRef()
    const contactRef = useRef()
    
    const refArr = [landingRef, servicesRef, portfolioRef, testimonialsRef, contactRef]

  

    return (
      <div>
        <Header  refArr={refArr}/>
        <div ref={landingRef}>
          <Landing />
        </div>
        <div className="scroll--padding"  ref={servicesRef}>
          <Services />
        </div>
        <div className="scroll--padding"  ref={portfolioRef}>
          <Portfolio />
        </div>
        <div className="scroll--padding"  ref={testimonialsRef}>
          <Testimonials />
        </div>
        <div className="scroll--padding"  ref={contactRef}>
          <Contact />
        </div>
      </div>
    )
  }
  
export default Main;
  